// @ts-nocheck

  import HomeOutlined from '@ant-design/icons/es/icons/HomeOutlined';
import BranchesOutlined from '@ant-design/icons/es/icons/BranchesOutlined';
import LineChartOutlined from '@ant-design/icons/es/icons/LineChartOutlined';
import CloudUploadOutlined from '@ant-design/icons/es/icons/CloudUploadOutlined';
import MessageOutlined from '@ant-design/icons/es/icons/MessageOutlined';
import ApiOutlined from '@ant-design/icons/es/icons/ApiOutlined';
import SettingOutlined from '@ant-design/icons/es/icons/SettingOutlined';
import ProfileOutlined from '@ant-design/icons/es/icons/ProfileOutlined';
import ToTopOutlined from '@ant-design/icons/es/icons/ToTopOutlined'
  export default {
    HomeOutlined,
BranchesOutlined,
LineChartOutlined,
CloudUploadOutlined,
MessageOutlined,
ApiOutlined,
SettingOutlined,
ProfileOutlined,
ToTopOutlined
  }